// extracted by mini-css-extract-plugin
export default {"copyButton":"CopyButton_copyButton__YGDbb","filterLight":"CopyButton_filterLight__+OLhs","filterDark":"CopyButton_filterDark__CIcKk"};